import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle, Loader2, ArrowRight } from "lucide-react";
import { SEO } from "@/components/shared";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [state, setState] = useState({ status: 'loading', message: '' });
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    if (!token) {
      setState({ status: 'error', message: 'This verification link is incomplete. Please use the link from your email.' });
      return;
    }
    fetch(`${API_URL}/api/contact/verify-link`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        setState(res.ok
          ? { status: 'success', message: data.message }
          : { status: 'error', message: data.detail || 'Verification failed.' });
      })
      .catch(() => setState({ status: 'error', message: 'Network error. Please try again.' }));
  }, [token]);

  const Icon = state.status === 'success' ? CheckCircle : state.status === 'error' ? XCircle : Loader2;

  return (
    <div className="pt-24">
      <SEO title="Email Verification" description="Verify your email to complete your enquiry with Qbic Catalyst Partners." path="/verify-email" />
      <section className="section bg-[#0A1628] min-h-[70vh] flex items-center">
        <div className="container-custom">
          <div className="max-w-xl mx-auto p-10 bg-[#121E30] border border-[#2A3648] rounded-xl text-center" data-testid="verify-email-card">
            <Icon
              size={56}
              className={`mx-auto mb-6 ${state.status === 'error' ? 'text-red-400' : 'text-[#C9A962]'} ${state.status === 'loading' ? 'animate-spin' : ''}`}
            />
            <h1 className="text-3xl font-bold mb-4" data-testid="verify-email-title">
              {state.status === 'success' ? 'Submitted' : state.status === 'error' ? 'Verification Unsuccessful' : 'Verifying your email...'}
            </h1>
            <p className="text-[#A0ABC0] mb-8" data-testid="verify-email-message">{state.message}</p>
            {state.status !== 'loading' && (
              <Link
                to={state.status === 'success' ? '/' : '/contact'}
                className="btn-primary inline-flex items-center gap-2"
                data-testid="verify-email-cta"
              >
                {state.status === 'success' ? 'Back to Home' : 'Go to Contact Form'} <ArrowRight size={18} />
              </Link>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
